<s1-input-label [label]="label">
  <input class="form-control" [ngClass]="{'is-invalid' : !checkIsValid() }" type="{{ type }}" [formControl]="control" [readonly]="readonly"/>
</s1-input-label>